var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../../elements/Loading';
import { FormGroup, Input, InputGroup, InputGroupText, Label, Tooltip, InputGroupAddon } from 'reactstrap';
import { t, T } from '../../../../helpers/i18n';
import theme from '../../../../Theme';
import { SearchInput } from '../../../../components';
import { Search } from '../../../../helpers/FuzzySearch';
import ToggleSelect from '../../../../elements/ToggleSelect';
var General = /** @class */ (function (_super) {
    __extends(General, _super);
    function General() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tooltipPrivate: false,
            tooltipPublic: false,
            copiedPublic: false,
            copiedPrivate: false,
            linkCopied: null,
            searchTerm: null,
            operationLineSelected: [],
            afiliateSelected: []
        };
        _this.copyTextToClipboard = function (text) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!('clipboard' in navigator)) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.clipboard.writeText(text)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, document.execCommand('copy', true, text)];
                }
            });
        }); };
        _this.handleCopyClick = function (target) {
            var text;
            var copiedPublic, copiedPrivate;
            if (target === 'publicApiToken') {
                text = _this.props.acount.publicApiToken;
                copiedPrivate = false;
                copiedPublic = true;
            }
            else {
                text = _this.props.acount.apiToken;
                copiedPrivate = true;
                copiedPublic = false;
            }
            _this.copyTextToClipboard(text);
            _this.setState({ copiedPublic: copiedPublic, copiedPrivate: copiedPrivate });
            _this.props.store.UI.newWarning(T('copiedToClipboard'));
        };
        _this.handleSearch = function (searchTerm) {
            // para evitar error Uncaught Error: The target 'Td_x_x' could not be identified in the dom
            _this.setState({ searchTerm: searchTerm || undefined });
        };
        _this.handleToggleSelect = function (value, type) {
            var selected = [];
            value.target.options.forEach(function (option) {
                if (option.selected) {
                    selected.push(option.value);
                }
            });
            var listSelected = [];
            if (type === 'afiliate') {
                listSelected = _this.state.afiliateSelected;
            }
            else if (type === 'operationLine') {
                listSelected = _this.state.operationLineSelected;
            }
            var intersection = listSelected.filter(function (element) { return selected.includes(element); });
            // para detectar si es deseleccionar
            if (intersection.length > 0) {
                if (type === 'operationLine') {
                    return _this.setState({ operationLineSelected: [] });
                }
                else if (type === 'afiliate') {
                    return _this.setState({ afiliateSelected: [] });
                }
            }
            if (type === 'operationLine') {
                _this.setState({ operationLineSelected: selected });
            }
            else if (type === 'afiliate') {
                _this.setState({ afiliateSelected: selected });
            }
        };
        return _this;
    }
    General.prototype.render = function () {
        var _this = this;
        var acount = this.props.acount;
        // console.log('acount: ', acount)
        if (!acount) {
            return null;
        }
        var operationLines = this.props.store.operationLines.data || [];
        var stretches = this.state.operationLineSelected.length > 0 ?
            this.props.store.stretches.data.filter(function (stretch) { return stretch.operationLine_id === _this.state.operationLineSelected[0]; }) || [] : this.props.store.stretches.data || [];
        var filteredItems = this.state.searchTerm ? Search(this.state.searchTerm, stretches, ['name', 'operationLineName']) : stretches;
        var afiliates = this.props.store.afiliateStore.data;
        var afiliateSelected = afiliates === null || afiliates === void 0 ? void 0 : afiliates.find(function (a) { var _a; return a.id === ((_a = _this.state.afiliateSelected) === null || _a === void 0 ? void 0 : _a[0]); });
        return (React.createElement("div", { style: {
                marginTop: '20px',
                marginLeft: '20px',
                marginRight: '20px',
                overflowY: 'hidden'
            } },
            React.createElement("h5", null, 'Módulo ecommerce'),
            React.createElement("h6", null, T('showCredentialsConnectEcommerce')),
            React.createElement("h6", { style: {
                    marginBottom: '30px'
                } }, T('noteNotShareToken')),
            React.createElement(FormGroup, null,
                React.createElement(Label, null, t('publicApiToken')),
                React.createElement(InputGroup, null,
                    React.createElement(InputGroupAddon, { addonType: "prepend" },
                        React.createElement(InputGroupText, { id: 'copy_public', onClick: function () { return _this.handleCopyClick('publicApiToken'); } },
                            React.createElement("i", { className: 'fa fa-clone', "aria-hidden": "true" }))),
                    React.createElement(Tooltip, { target: 'copy_public', isOpen: this.state.tooltipPublic, toggle: function () { return _this.setState(function (prev) { return ({ tooltipPublic: !prev.tooltipPublic }); }); } }, T('copyToClipboard')),
                    React.createElement(Input, { disabled: true, value: acount.publicApiToken, style: this.state.copiedPublic ?
                            {
                                borderColor: theme.color.primary
                            } :
                            {} }))),
            React.createElement(FormGroup, null,
                React.createElement(Label, null, t('apiToken')),
                React.createElement(InputGroup, null,
                    React.createElement(InputGroupAddon, { addonType: "prepend" },
                        React.createElement(InputGroupText, { id: 'copy_private' },
                            React.createElement("span", { onClick: function () { return _this.handleCopyClick('privateApiToken'); } },
                                React.createElement("i", { className: 'fa fa-clone', "aria-hidden": "true" })))),
                    React.createElement(Tooltip, { target: 'copy_private', isOpen: this.state.tooltipPrivate, toggle: function () { return _this.setState(function (prev) { return ({ tooltipPrivate: !prev.tooltipPrivate }); }); } }, T('copyToClipboard')),
                    React.createElement(Input, { disabled: true, value: acount.apiToken, style: this.state.copiedPrivate ?
                            {
                                borderColor: theme.color.primary
                            } :
                            {} }))),
            React.createElement("div", null,
                React.createElement(FormGroup, null,
                    React.createElement(Label, null, t('afiliate')),
                    React.createElement(ToggleSelect, { onChange: function (v) { return _this.handleToggleSelect(v, 'afiliate'); }, options: afiliates.map(function (afiliate) { return ({
                            id: afiliate.id,
                            // @ts-ignore
                            name: afiliate.name,
                            value: afiliate.id,
                            selected: !!_this.state.afiliateSelected.find(function (ols) { return ols === afiliate.id; }),
                        }); }) }),
                    React.createElement(Label, null, t('serviceLinks')),
                    React.createElement(ToggleSelect, { onChange: function (v) { return _this.handleToggleSelect(v, 'operationLine'); }, options: operationLines.map(function (operationLine) { return ({
                            id: operationLine.id,
                            // @ts-ignore
                            name: operationLine.name,
                            value: operationLine.id,
                            selected: !!_this.state.operationLineSelected.find(function (ols) { return ols === operationLine.id; }),
                        }); }) }),
                    React.createElement(SearchInput, { underline: true, onChange: this.handleSearch }),
                    filteredItems.map(function (stretch) {
                        var text = "https://widget.ticando.net/".concat(_this.props.acount.publicApiToken, "/trayecto/").concat(stretch.id, "/").concat(stretch.operationLine_id).concat(afiliateSelected ? "?at=".concat(afiliateSelected.publicToken) : '');
                        return (React.createElement(InputGroup, { key: 'input_group_' + stretch.id },
                            React.createElement(InputGroupAddon, { addonType: "prepend" },
                                React.createElement(InputGroupText, { id: 'copy_link_' + stretch.id },
                                    React.createElement("span", { onClick: function () {
                                            _this.copyTextToClipboard(text);
                                            _this.setState({ linkCopied: stretch.id });
                                            _this.props.store.UI.newWarning(T('copiedToClipboard'));
                                        } },
                                        React.createElement("i", { className: 'fa fa-clone', "aria-hidden": "true" })))),
                            React.createElement(Input, { disabled: true, value: stretch.name, style: _this.state.linkCopied === stretch.id ?
                                    {
                                        borderColor: theme.color.primary
                                    } :
                                    {} }),
                            React.createElement(Input, { disabled: true, value: text, style: _this.state.linkCopied === stretch.id ?
                                    {
                                        borderColor: theme.color.primary
                                    } :
                                    {} })));
                    })))));
    };
    General = __decorate([
        inject('store'),
        observer,
        loading(function (props) { return [
            // props.store.acountStore.read().then(acount => ({acount})),
            props.store.stretches.readSelect('id,name,operationLine_id'),
            props.store.operationLines.readSelect('id,name'),
            props.store.afiliateStore.read(),
        ]; })
    ], General);
    return General;
}(Component));
export { General };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/container/Ecommerce/General.tsx
// module id = 1580
// module chunks = 0